import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import "../../styles/assets/assets.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import IconSelector from "../commoncomponents/IconSelector";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class CreateAsset extends Component {

  Constants = { defaultProfile: "Truck" };

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      friendlyName: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profileId: "",
      profileName: "",
      vehicleTypes: [],
      licenceClass: "",
      vehicleTypeId: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: 1,
      statusName: "Awaiting Install",
      error: false,
      micTick: false,
      sosTick: false,
      tempaTick: false,
      tempbTick: false,
      harshTick: false,
      driverTick: false,
      dashTick: false,
      doorSensorTick: false,
      customerError: false,
      nameError: false,
      tag1Error: false,
      tag2Error: false,
      descriptionError: false,
      profileError: false,
      featureError: false,
      colorError: false,
      iconError: false,
      noteError: false,
      adminNoteError: false,
      statusError: false,
    };
    this.micTick = false;
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({
        customerName: values.selectedAsset,
        customerId: values.customerId,
      });
    }
    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
    }
    this.getProfiles();
    this.getStatus();
    this.getVehicleTypes();
  }

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getProfiles = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllProfile`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        const profiles = response.data || [];
        const defaultProfile = profiles.find(
          (profile) => profile.profileName === this.Constants.defaultProfile
        );

        this.setState({
          profiles,
          profileId: defaultProfile ? defaultProfile.id : "",
          profileName: defaultProfile ? defaultProfile.profileName : "",
          color: this.state.color || "#160f9e",
          icon: this.state.icon || "fa fa-truck",
        });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllStatus`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ status: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getVehicleTypes = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetVehicleTypes`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ vehicleTypes: response.data || [] });
      }
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handlefriendlyName = (evt) => {
    this.setState({ friendlyName: evt.target.value });
  };

  handleTag1 = (evt) => {
    this.setState({ tag1: evt.target.value });
  };

  handleTag2 = (evt) => {
    this.setState({ tag2: evt.target.value });
  };

  handleCustomer = (evt) => {
    const customerId = evt.target.value;
    const selectedCustomer = this.state.customers.find(
      (customer) => customer.id.toString() === customerId
    );

    if (selectedCustomer) {
      this.setState({
        customerId: selectedCustomer.id.toString(),
        customerName: selectedCustomer.name,
        customerError: false,
      });
    } else {
      this.setState({
        customerId: "",
        customerName: "",
        customerError: true,
      });
    }
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleProfile = (evt) => {
    this.state.profiles.forEach((profile) => {
      if (profile.profileName == evt.target.value) {
        this.setState({
          profileId: profile.id,
          profileName: profile.profileName,
        });
      }
      if (evt.target.value !== "") {
        this.setState({ profileError: false });
      }
    });
  };

  handleColor = (evt) => {
    this.setState({ color: evt.target.value });
  };

  getColorPickerValue = () => {
    const color = String(this.state.color || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : "#160f9e";
  };

  handleIcon = (evt) => {
    this.setState({ icon: evt.target.value });
  };

  handleIconSelection = (icon) => {
    this.setState({ icon });
  };

  handleVisualDefaults = () => {
    this.setState({
      color: "#160f9e",
      icon: "fa fa-truck",
    });
  };

  handleNotes = (evt) => {
    this.setState({ notes: evt.target.value });
  };

  handleAdminNotes = (evt) => {
    this.setState({ adminNotes: evt.target.value });
  };

  handleStatus = (evt) => {
    this.setState({ statusError: evt.target.value == "" });
    this.state.status.forEach((stats) => {
      if (stats.name == evt.target.value) {
        console.log(stats.name);
        this.setState({ statusId: stats.id, statusName: stats.name });
      }
    });
  };

  handleLicenceClass = (evt) => {
    this.setState({ licenceClass: evt.target.value });
  };

  handleVehicleType = (evt) => {
    this.setState({ vehicleTypeId: evt.target.value ? parseInt(evt.target.value, 10) : "" });
  };

  handleCreate = async () => {
    this.validationCheck();
    const {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      customerId,
      color,
      icon,
      notes,
      adminNotes,
      profileId,
      statusId,
      profileName,
      statusName,
      licenceClass,
      vehicleTypeId,
    } = this.state;

    if (name && customerId && profileId && statusId) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Assets/AssetRegister`,
          {
            Name: name,
            FriendlyName: friendlyName,
            Description: description,
            CustomerId: customerId,
            Tag1: tag1,
            Tag2: tag2,
            ProfilesId: profileId,
            ProfilesName: profileName,
            Features: 20,
            Colour: color,
            Icon: icon,
            Notes: notes,
            AdminNotes: adminNotes,
            StatusId: statusId,
            StatusName: statusName,
            ExternalId: 111,
            SpeakerandMic: this.state.micTick,
            SOSDuress: this.state.sosTick,
            TempA: this.state.tempaTick,
            TempB: this.state.tempbTick,
            HarshEvents: this.state.harshTick,
            DriverID: this.state.driverTick,
            DashCamera: this.state.dashTick,
            DoorSensor: this.state.doorSensorTick,
            LicenceClass: licenceClass,
            VehicleTypeId: vehicleTypeId || null,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          //this.props.history.push("/assets");
          this.props.history.goBack();
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          // this.props.setErrorMessageAction(`${e}`);
          if (e.response.data.statusCode == "8") {
            this.props.setErrorMessageAction("Asset Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }

    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }

    if (!this.state.profileId) {
      this.setState({ profileError: true });
    }

    if (!this.state.statusId) {
      this.setState({ statusError: true });
    }
  };

  handleBack = () => {
    // this.props.history.push('/assets');
    this.props.history.goBack();
  };

  handleMic = (e) => {
    this.setState({ micTick: !this.state.micTick });
    this.micTick = !this.micTick;
  };
  handleSos = (e) => {
    this.setState({ sosTick: !this.state.sosTick });
  };

  handleTempA = (e) => {
    this.setState({ tempaTick: !this.state.tempaTick });
  };

  handleTempB = (e) => {
    this.setState({ tempbTick: !this.state.tempbTick });
  };

  handleHarsh = (e) => {
    this.setState({ harshTick: !this.state.harshTick });
  };

  handleDriver = (e) => {
    this.setState({ driverTick: !this.state.driverTick });
  };

  handleDash = (e) => {
    this.setState({ dashTick: !this.state.dashTick });
  };

  handleDoorSensor = (e) => {
    this.setState({ doorSensorTick: !this.state.doorSensorTick });
  };

  render() {
    const {
      customers,
      profiles,
      status,
      vehicleTypes,
      customerName,
      customerError,
      nameError,
      tag1Error,
      tag2Error,
      profileError,
      descriptionError,
      noteError,
      adminNoteError,
      iconError,
      colorError,
      statusError,
      licenceClass,
      vehicleTypeId,
    } = this.state;
    const isSystemAdmin = localStorage.getItem('role') === "SystemAdmin";

    const selectCustomerTag = (
      <Form.Control
        as="select"
        onChange={this.handleCustomer}
        value={this.state.customerId || "default"}
      >
        <option value="default" disabled>
          Select Customer
        </option>
        {customers.map((customer) => (
          <option key={customer.id} value={customer.id}>
            {customer.name}
          </option>
        ))}
      </Form.Control>
    );

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>New Asset </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper asset-edit-page">
              <div className="asset-edit-header">
                <div>
                  <span className="asset-edit-kicker">Asset creator</span>
                  <h2>New Asset</h2>
                  <div className="asset-edit-subtitle">
                    <span>{customerName || "Select customer"}</span>
                    <span>{this.state.profileName || this.Constants.defaultProfile}</span>
                    <span className={`asset-status-badge asset-status-badge-${(this.state.statusName || "").toLowerCase().replace(/\s+/g, "-")}`}>
                      {this.state.statusName === "Disable" ? "Disabled" : this.state.statusName}
                    </span>
                  </div>
                </div>
                <div className="asset-edit-actions">
                  <Button variant="outline-secondary" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Create Asset
                  </Button>
                </div>
              </div>

              <Form className="asset-edit-form-modern">
                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Asset Identity</h3>
                    <p>Customer ownership, naming and descriptive details.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetCustomer">
                      <Form.Label>Customer</Form.Label>
                      {selectCustomerTag}
                      <p style={customerError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Customer field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control onChange={this.handleName} type="text" />
                      <p style={nameError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetFriendlyName">
                      <Form.Label>Friendly Name</Form.Label>
                      <Form.Control onChange={this.handlefriendlyName} type="text" />
                    </Form.Group>

                    <Form.Group controlId="assetTag1">
                      <Form.Label>Tag1</Form.Label>
                      <Form.Control onChange={this.handleTag1} type="text" />
                      <p style={tag1Error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Tag1 field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetTag2">
                      <Form.Label>Tag2</Form.Label>
                      <Form.Control onChange={this.handleTag2} type="text" />
                      <p style={tag2Error ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Tag2 field is required.
                      </p>
                    </Form.Group>

                    <Form.Group className="asset-edit-wide" controlId="assetDescription">
                      <Form.Label>Description</Form.Label>
                      <Form.Control as="textarea" rows="3" onChange={this.handleDescription} />
                      <p style={descriptionError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Description field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Configuration</h3>
                    <p>Profile, status, colour and icon used across the platform.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetProfile">
                      <Form.Label>Profile</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleProfile}
                        value={this.state.profileName || "default"}
                      >
                        <option value="default">Select Profile</option>
                        {profiles.map((profile, index) => (
                          <option key={index} value={profile.profileName}>{profile.profileName}</option>
                        ))}
                      </Form.Control>
                      <p style={profileError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Profile field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.statusName}
                        onChange={this.handleStatus}
                      >
                        {status.map((stats, index) => (
                          <option key={index} value={stats.name}>{stats.name}</option>
                        ))}
                      </Form.Control>
                      <p style={statusError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Status field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="assetColour">
                      <Form.Label>Colour</Form.Label>
                      <div className="colour-picker-field">
                      <Form.Control
                        value={this.getColorPickerValue()}
                        onChange={this.handleColor}
                        type="color"
                        title="Choose colour"
                      />
                      <Form.Control
                        value={this.state.color}
                        onChange={this.handleColor}
                        type="text"
                        placeholder=""
                      />
                      </div>
                      <p style={colorError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Color field is required.
                      </p>
                    </Form.Group>

                    <Form.Group className="asset-edit-wide" controlId="assetIcon">
                      <Form.Label>Icon</Form.Label>
                      <IconSelector
                        value={this.state.icon}
                        onChange={this.handleIconSelection}
                      />
                      <div className="asset-edit-icon-row">
                        <Form.Control
                          value={this.state.icon}
                          onChange={this.handleIcon}
                          type="text"
                        />
                        <button type="button" className="visual-default-button" onClick={this.handleVisualDefaults}>
                          Back to default
                        </button>
                      </div>
                      <p style={iconError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Icon field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Features</h3>
                    <p>Available hardware and alert capabilities for this asset.</p>
                  </div>
                  <div className="asset-feature-toggle-grid">
                    <Form.Check checked={this.state.micTick} onChange={(e) => this.handleMic(e)} label="Speaker & Mic" type="checkbox" />
                    <Form.Check checked={this.state.sosTick} onChange={(e) => this.handleSos(e)} label="SOS (Duress)" type="checkbox" />
                    <Form.Check checked={this.state.tempaTick} onChange={(e) => this.handleTempA(e)} label="Temp A" type="checkbox" />
                    <Form.Check checked={this.state.tempbTick} onChange={(e) => this.handleTempB(e)} label="Temp B" type="checkbox" />
                    <Form.Check checked={this.state.harshTick} onChange={(e) => this.handleHarsh(e)} label="Harsh Events" type="checkbox" />
                    <Form.Check checked={this.state.driverTick} onChange={(e) => this.handleDriver(e)} label="Driver ID (Fob Key)" type="checkbox" />
                    <Form.Check checked={this.state.dashTick} onChange={(e) => this.handleDash(e)} label="Dash Camera" type="checkbox" />
                    <Form.Check checked={this.state.doorSensorTick} onChange={(e) => this.handleDoorSensor(e)} label="Door Sensor" type="checkbox" />
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>QR Driver Authentication</h3>
                    <p>Vehicle type and licence requirement used by the QR driver PIN workflow.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group controlId="assetVehicleType">
                      <Form.Label>Vehicle Type</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleVehicleType}
                        value={vehicleTypeId || ""}
                      >
                        <option value="">Select vehicle type</option>
                        {vehicleTypes.map((type) => (
                          <option key={type.id} value={type.id}>{type.name}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="assetLicenceClass">
                      <Form.Label>Required Licence Class</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={this.handleLicenceClass}
                        value={licenceClass || ""}
                      >
                        <option value="">No licence requirement</option>
                        {["C", "LR", "MR", "HR", "HC", "MC", "RE", "R"].map((licence) => (
                          <option key={licence} value={licence}>{licence}</option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </div>
                </section>

                <section className="asset-edit-section">
                  <div className="asset-edit-section-title">
                    <h3>Notes</h3>
                    <p>Operational and administrator notes for the new asset.</p>
                  </div>
                  <div className="asset-edit-grid">
                    <Form.Group className="asset-edit-wide" controlId="assetNotes">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control as="textarea" rows="3" onChange={this.handleNotes} />
                      <p style={noteError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Note field is required.
                      </p>
                    </Form.Group>

                    {isSystemAdmin && (
                      <Form.Group className="asset-edit-wide" controlId="assetAdminNotes">
                        <Form.Label>Admin Notes</Form.Label>
                        <Form.Control as="textarea" rows="3" onChange={this.handleAdminNotes} />
                        <p style={adminNoteError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                          The AdminNote field is required.
                        </p>
                      </Form.Group>
                    )}
                  </div>
                </section>

                {this.state.error && (
                  <p className="error-text asset-edit-error">
                    Please fill all the Required fields
                  </p>
                )}

                <div className="asset-edit-footer">
                  <Button variant="outline-secondary" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Create Asset
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAsset);
